"use client";

import React from "react";

export default function HealthCheckCSR() {
  return <div>HealthCheck</div>;
}
